<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="addData">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="delButton(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 title="调度计划告警策略"
                 width="40%"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="getData">
            <a-row>
                <a-col :span="3"/>
                <a-col :span="5">
                    序号：
                </a-col>
                <a-col :span="12">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="5">
                    名称：
                </a-col>
                <a-col :span="12">
                    <a-input v-model.trim="form.descpt"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="5">
                    静止时间(m)：
                </a-col>
                <a-col :span="12">
                    <a-input-number style="width: 100%" v-model.trim="form.staticTime"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="5">
                    备注：
                </a-col>
                <a-col :span="12">
                    <a-input v-model.trim="form.remark"/>
                </a-col>
            </a-row>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getDispatchTacticsList, dispatchTacticsEditDetail, dispatchTacticsDelDetail} from './js/ApiDispatch';

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '名称',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '静止时间',
            dataIndex: 'staticTime',
            key: 'staticTime',
            ellipsis: true,
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                visible: false,
                delVisible: false,
                car: [],
                data: {},
                lines: {},
                form: {
                    orderNo: '',
                    staticTime: '',
                    descpt: '',
                    remark: '',
                },
            }
        },
        methods: {
            // 新增按钮
            addData() {
                this.visible = true;
            },
            //新增-点击确定
            add() {
                this.form.orderNo = this.form.orderNo + '';
                this.form.staticTime = this.form.staticTime + '';
                dispatchTacticsEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            // 删除
            delButton(row) {
                this.lines = row;
                this.delVisible = true;
            },
            delOk() {
                this.delVisible = false;
                dispatchTacticsDelDetail({id: this.lines.id}).then(() => {
                    this.getData();
                });
            },
            cancel() {
                this.delVisible = false;
            },
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getDispatchTacticsList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    key: '',
                    value: '',
                    descpt: '',
                    remark: '',
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                this.getData({baseDto: baseDto});
            },
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped>
    .Tips {
        font-size: 25px;
        color: #1890ff;
    }
</style>
